import { render, staticRenderFns } from "./SiteServiceType.vue?vue&type=template&id=6fff7861&scoped=true&"
import script from "./SiteServiceType.vue?vue&type=script&lang=js&"
export * from "./SiteServiceType.vue?vue&type=script&lang=js&"
import style0 from "./SiteServiceType.vue?vue&type=style&index=0&id=6fff7861&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fff7861",
  null
  
)

export default component.exports